export default "__VITE_ASSET__DIEHCH2l__"